import { GameStatues, IGame } from "@grassrootly/api/entities/IGame";
import { GetPlayerGamesPayload } from "@grassrootly/api/gateways/player";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const GetPlayerGames = async (payload: GetPlayerGamesPayload): Promise<IGame[]> => {
  const groupMappers = withErrorCheck(
    await server.from("GroupPlayers").select("group_id").eq("player_id", payload.playerId)
  );

  const groups = withErrorCheck(
    await server
      .from("Groups")
      .select("*")
      .in(
        "id",
        groupMappers.map((g) => g.group_id)
      )
  );
  const games = withErrorCheck(
    await server
      .from("Games")
      .select("*")
      .in(
        "group_id",
        groups.map((g) => g.id)
      )
      .order("datetime", { ascending: false })
  );
  const gameAttendees = withErrorCheck(
    await server
      .from("GameAttendances")
      .select("*")
      .in(
        "game_id",
        games.map((g) => g.id)
      )
      .order("attended", { ascending: false, nullsFirst: false })
  );
  const players = withErrorCheck(
    await server
      .from("Players")
      .select("*")
      .in(
        "id",
        gameAttendees.map((ga) => ga.player_id)
      )
  );
  return games.map((game) => {
    const att = gameAttendees
      .filter((ga) => ga.game_id == game.id)
      .sort((a, b) => (game.status === GameStatues.FINALIZED ? b.points_earned - a.points_earned : 0))
      .map((ga) => {
        return {
          ...ga,
          player: players.find((p) => p.id == ga.player_id)!,
        };
      });
    return {
      ...game,
      status: game.status as GameStatues,
      group: groups.find((g) => g.id === game.group_id)!,
      attendees: att,
    };
  });
};
